export default {

    async addToGroup(state, payload) {
        // console.log('user id id id', payload.id)
        // const group = state.connectionGroups.find(g => g.id === payload.groupId);
        // const member = {
        //     id: payload.id,
        //     firstName: payload.firstName,
        //     lastName: payload.lastName
        // }

        // if (group.members === undefined) {
        //     group.members = new Array();
        // }

        // const token = state.rootGetters.token;

        // group.members.push(member)
        // const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups/${group.id}.json?auth=` + token, {
        //     method: 'PATCH',
        //     body: JSON.stringify({
        //         groupName: group.groupName,
        //         groupLeader: group.groupLeader,
        //         members: group.members,
        //         notes: group.notes
        //     })
        // });
        // const responseData = await response.json();
        // if (!response.ok) {
        //     const error = new Error(responseData.message || 'Failed to send request');
        //     throw error;
        // }
        console.log(payload)
    },

    async addNoteToGroup(state, payload) {
        console.log(payload)
        const note = {
            id: payload.id,
            note: payload.note
        }
        const group = state.connectionGroups.find(group => group.id === payload.groupId);
        group.notes.push(note);
    },

    removeFromGroup(state, payload) {
        console.log('payload in mutations', payload)
        const group = state.connectionGroups.find(g => g.id === payload.id);
        console.log(group)
        const existingMember = group.members.find(m => m.id === payload.memberId)
        console.log(existingMember)
        const newMembers = group.members.filter(member => member.id != existingMember.id);
        group.members = newMembers
        console.log('newGroup', group)

    },

    registerGroup(state, payload) {
        fetch('https://trackingmembers-a1654-default-rtdb.firebaseio.com/groups.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                groupName: payload.groupName,
                groupLeader: payload.groupLeader,
            })
        });
    },

    setGroups(state, payload) {
        state.connectionGroups = payload;
    },

    removeAgroup(state, payload) {
        console.log('payload in removeAgroup mutation', payload)
        state.connectionGroups = state.connectionGroups.filter(g => g.id != payload.id)
    },

    removeNote(state, payload) {
        console.log('payload in removeNote', payload)
        const group = state.connectionGroups.find(g => g.id === payload.id)
        group.notes = group.notes.filter(note => note.id != payload.noteId);
        const arrayToMap = []
        arrayToMap.push(group);
        state.connectionGroups.map(group => arrayToMap.find(g => g.id === group.id) || group);


    }

}